import { render } from "./ReserveInfoDetail_non.vue?vue&type=template&id=5fd91eaf"
import script from "./ReserveInfoDetail_non.vue?vue&type=script&lang=js"
export * from "./ReserveInfoDetail_non.vue?vue&type=script&lang=js"

import "./ReserveInfoDetail_non.vue?vue&type=style&index=0&id=5fd91eaf&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__